import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {ELearningPageRoutingModule} from './e-learning-routing.module';
import {ELearningListComponent} from './e-learning-list/e-learning-list.component';
import {ELearningReportComponent} from './e-learning-report/e-learning-report.component';
import {ComponentsModule} from '../components/components.module';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ELearningPageRoutingModule,
        ComponentsModule,
        TranslateModule.forChild()
    ],
    declarations: [
        ELearningListComponent,
        ELearningReportComponent
    ]
})
export class ELearningModule {
}
